import {Component} from 'react';
import {doubleToStringMonthly, standardNumberFormat} from '../../objects/CommonUse/double_functions';
import reformatDateToDisplay from '../../objects/CommonUse/reformatDateToDisplay_function';



class FourColumnDisplayCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            selected: false
        };
    }

    formatDataForOutput(){
        if (!this.props.tableType){
            this.tableType = "label-quantity-quantity-quantity";
        }else{
            this.tableType = this.props.tableType;
        }
        this.rowClass = "";
        this.secondColumnClass = "text-right p-0";
        this.thirdColumnClass = "text-right p-0";
        this.fourthColumnClass = "text-right p-0";
        switch (this.tableType){
            case "label-quantity-quantity-quantity":
                this.column1 = this.props.tableInfo.column1;
                this.column2 = standardNumberFormat(this.props.tableInfo.column2);
                this.column3 = standardNumberFormat(this.props.tableInfo.column3);
                this.column4 = standardNumberFormat(this.props.tableInfo.column4);
                this.firstColumnClass = "text-left";
                break;
            case "label-quantity-amount-amount":
                this.column1 = this.props.tableInfo.column1;
                this.column2 =  standardNumberFormat(this.props.tableInfo.column2);
                this.column3 = doubleToStringMonthly(this.props.tableInfo.column3);
                this.column4 = doubleToStringMonthly(this.props.tableInfo.column4);
                this.firstColumnClass = "text-left font-weight-bold";
                break;
            case "date-amount-string-string":
                this.column1 = reformatDateToDisplay(this.props.tableInfo.column1);
                this.column2 = doubleToStringMonthly(this.props.tableInfo.column2);
                this.column3 = this.props.tableInfo.column3;
                if (this.props.tableInfo.column4 === undefined){
                    this.column4 = "";
                }else{
                    if (isNaN(this.props.tableInfo.column4)){
                        this.column4 = this.props.tableInfo.column4;
                    }else{
                        this.column4 = doubleToStringMonthly(this.props.tableInfo.column4);
                    }
                }
                this.firstColumnClass = "text-center";
                this.thirdColumnClass = "text-center p-0";
                this.fourthColumnClass = "text-center p-0"
                this.rowClass = this.props.tableInfo.rowClass;
                break;
            default:
                break;
        }
    }


    render() {
           this.formatDataForOutput();
    return <>
        <tr className={this.rowClass}>
            <td className={this.firstColumnClass}>{this.column1}</td>
            <td className={this.secondColumnClass}>{this.column2}</td>
            <td className={this.thirdColumnClass}>{this.column3}</td>
            <td className={this.fourthColumnClass}>{this.column4}</td>
        </tr>

    </>
    }
}

export default FourColumnDisplayCard;